import { Input } from '@components/core-ui/form-elements/Input';
import { FirstFormRowWrapper } from './styles/FirstFormRowWrapper';
import { InputWrapper } from './styles/InputWrapper';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  name: string;
  slug: string;
};

export const WorkspaceDetailsForm = ({ name, slug }: TProps) => {
  return (
    <Wrapper>
      <div className="leftSide">
        <h3>General</h3>
      </div>

      <div className="rightSide">
        <div className="rightSide-columns">
          <FirstFormRowWrapper>
            <InputWrapper>
              <label htmlFor="name">Workspace name</label>
              <Input
                className="form-input w-full"
                disabled={true}
                onChange={() => {}}
                name="name"
                value={name}
                label="Workspace name"
              />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="slug">Workspace URL</label>
              <Input
                className="form-input w-full"
                disabled={true}
                name="slug"
                value={slug}
                label="Workspace URL"
                onChange={() => {}}
              />
            </InputWrapper>
          </FirstFormRowWrapper>
        </div>
      </div>
    </Wrapper>
  );
};
